import { ref } from 'vue'

export type ConfirmOptions = {
  title?: string
  message: string
  okText?: string
  cancelText?: string
  size?: 'small' | 'medium' | 'large'
  maxWidth?: string | number
}

const confirmOpen = ref(false)
const confirmTitle = ref('')
const confirmMessage = ref('')
const confirmOkText = ref('OK')
const confirmCancelText = ref('Cancel')
const confirmMaxWidth = ref<string | number>(420)

let resolveConfirm: ((value: boolean) => void) | null = null

export function useAppModal() {
  const confirm = (options: ConfirmOptions): Promise<boolean> => {
    confirmTitle.value = options.title ?? 'Confirm'
    confirmMessage.value = options.message
    confirmOkText.value = options.okText ?? 'OK'
    confirmCancelText.value = options.cancelText ?? 'Cancel'
    confirmMaxWidth.value = options.maxWidth ?? 420
    confirmOpen.value = true

    return new Promise((resolve) => {
      resolveConfirm = resolve
    })
  }

  const acceptConfirm = () => {
    confirmOpen.value = false
    resolveConfirm?.(true)
    resolveConfirm = null
  }

  const rejectConfirm = () => {
    confirmOpen.value = false
    resolveConfirm?.(false)
    resolveConfirm = null
  }

  return {
    confirm,
    acceptConfirm,
    rejectConfirm,
    confirmOpen,
    confirmTitle,
    confirmMessage,
    confirmOkText,
    confirmCancelText,
    confirmMaxWidth,
  }
}

/** @deprecated Use useAppModal */
export const useModal = useAppModal
